"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.every = void 0;
var operators_1 = require("rxjs/operators");
var combine_latest_1 = require("../combine-latest");
var every = function () {
    var conditions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        conditions[_i] = arguments[_i];
    }
    return (0, combine_latest_1.combineLatestTyped)(conditions).pipe((0, operators_1.map)(function (cs) { return cs.every(function (e) { return e; }); }));
};
exports.every = every;
